import Vue from 'vue';

Vue.component('disclaimer-with-preview-component', {
    props: {
        disclaimerPreview: {
            type: String,
            default: '',
        },
        disclaimerText: {
            type: String,
            default: '',
        },
        openText: {
            type: String,
            default: '',
        },
        closeText: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            isExpandable: true,
            isExpanded: false,
            actionText: '',
        };
    },

    mounted() {
        this.isExpandable = Boolean(this.disclaimerPreview);
        this.actionText = this.openText || '';
    },

    methods: {
        toggleExpand() {
            this.isExpanded = !this.isExpanded;
            this.actionText = this.isExpanded ? this.closeText : this.openText;
        },
    },
});
